import { render, staticRenderFns } from "./gateways.vue?vue&type=template&id=42414b65&"
import script from "./gateways.vue?vue&type=script&lang=js&"
export * from "./gateways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports